import { Component, computed, input, output } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { ClassValue } from 'clsx';

const chipFilteringVariants = cva('gap-xxs px-sm py-xs flex rounded-full border', {
  variants: {
    variant: {
      default: 'bg-components-background-neutral-lightest border-stroke-neutral-medium',
      informative:
        'bg-components-background-primary-lightest border-stroke-primary-darker text-components-content-primary-darker [&>button]:text-components-content-primary-darker',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ChipFilteringVariants = VariantProps<typeof chipFilteringVariants>;

@Component({
  selector: 'app-chip-filtering',
  imports: [HlmIconImports, HlmButtonImports],
  providers: [provideIcons({ lucideX })],
  template: `
    <div [class]="_computedClass()">
      <span class="component-small-medium">{{ label() }}</span>
      <button (click)="remove.emit()" hlmBtn variant="ghost" size="compact">
        <ng-icon hlm size="sm" name="lucideX" />
      </button>
    </div>
  `,
})
export class ChipFilteringComponent {
  readonly label = input.required<string>();

  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(chipFilteringVariants({ variant: this.variant() }), this.userClass()),
  );
  readonly variant = input<ChipFilteringVariants['variant']>('default');

  remove = output();
}
